module.exports = __webpack_public_path__ + "img/karta_platnicza.145a84e3.png";